import type { ReactNode } from 'react';
import { useMatch } from 'react-router';

import { AppErrorBoundary } from '@/shared/ui/app-error-boundary/AppErrorBoundary';

type RouteErrorBoundaryProps = {
  children: ReactNode;
  routePath: string;
};

export function RouteErrorBoundary({ children, routePath }: RouteErrorBoundaryProps) {
  const routeMatch = useMatch({ path: routePath, end: false });
  const routeKey = routeMatch?.pathname ?? routePath;

  return (
    <AppErrorBoundary key={routeKey} boundaryId="route-content">
      {children}
    </AppErrorBoundary>
  );
}
